import { render, staticRenderFns } from "./ResearchGroupInfo.html?vue&type=template&id=5e7b6653&scoped=true&"
import script from "./ResearchGroupInfo.vue?vue&type=script&lang=js&"
export * from "./ResearchGroupInfo.vue?vue&type=script&lang=js&"
import style0 from "./ResearchGroupInfo.scss?vue&type=style&index=0&id=5e7b6653&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7b6653",
  null
  
)

export default component.exports